export default __webpack_public_path__ + "static/media/molar-I.c110acb7.png";